import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateCouponEntity } from '../../domain/entities/CreateCouponEntity'
import type { StdioNull } from 'node:child_process'
import { CreateUpdateCouponRegionModel } from './CreateUpdateCouponRegionModel'

export class CreateCouponModel extends CreateCouponEntity {
  userIds?: Array<string> | null
  branchIds?: Array<number> | StdioNull
  channelIds?: Array<number> | null
  groupIds?: Array<number> | null

  constructor(dataDto: CreateCouponEntity) {
    super()
    const couponRegionModels = dataDto.regions?.map(
      (region) => new CreateUpdateCouponRegionModel(region)
    )
    mapEntityProperties<CreateCouponModel>(this, dataDto, {
      exclude: ['users', 'branches', 'channels', 'groups', 'imageUrl'],
      map: {
        userIds: dataDto?.users?.map((user) => user.id),
        branchIds: dataDto?.branches?.map((branch) => branch.id),
        channelIds: dataDto?.channels?.map((channel) => channel.id),
        groupIds: dataDto?.groups?.map((group) => group.id),
        regions: couponRegionModels,
        onDelivery:
          dataDto.onDelivery &&
          dataDto.onDelivery.discountType &&
          dataDto.onDelivery.discountValue !== undefined
            ? {
                ...dataDto.onDelivery,
                limitedBranchShareAmount: dataDto.onDelivery?.limitedBranchShareAmount,
                serviceRatio:
                  dataDto.onDelivery?.limitedBranchShareAmount !== undefined &&
                  dataDto.onDelivery?.limitedBranchShareAmount !== null
                    ? null
                    : dataDto.onDelivery?.serviceRatio,
                branchRatio:
                  dataDto.onDelivery?.limitedBranchShareAmount !== undefined &&
                  dataDto.onDelivery?.limitedBranchShareAmount !== null
                    ? null
                    : dataDto.onDelivery?.branchRatio
              }
            : undefined,
        onItem:
          dataDto.onItem &&
          dataDto.onItem.discountType &&
          dataDto.onItem.discountValue !== undefined
            ? dataDto.onItem
            : undefined
      }
    })
  }
}
